import { DataflowFloatTextFieldProps } from './DataflowFloatTextField.types'
import useDataflowFloatTextField from './useDataflowFloatTextField'
import { TextField } from '@mui/material'

const DataflowFloatTextField = (props: DataflowFloatTextFieldProps) => {
  const { handleChange, ...rest } = useDataflowFloatTextField(props)

  return <TextField {...rest} onChange={handleChange} />
}

export default DataflowFloatTextField
